<template>
  <div class="uiwu">
      <uiwu-head /> 
        <uiwu-index-banner  />  
        <div class="uiwu-index uiwu-box">
            
            <div class="uiwu-index-gard uiwu-flex">
                <uiwu-index-item class="uiwu-index-gard-item" v-for="(item,index) in gardlist" :key="index" :item="item" />
            </div>
            
             <ul class="uiwu-index-num uiwu-flex">
                 <li class="uiwu-flex-column">
                     <span>全球知名软件</span>
                     <p>10款+</p>
                 </li>
                 <li class="uiwu-flex-column">
                     <span>行业领域深耕</span>
                     <p>13年+</p>
                 </li>
                 <li class="uiwu-flex-column">
                     <span>覆盖国家地区</span>
                     <p>160个+</p>
                 </li>
                <li class="uiwu-flex-column">
                     <span>累计用户数量</span>
                     <p>6000万+</p>
                 </li>
             </ul>
        </div>
  </div>
</template>

<script>
import uiwuIndexItem from '@/components/index/item.vue' // 模块
import uiwuIndexBanner from '@/components/index/banner.vue' // 模块
export default {
  components: {uiwuIndexItem ,uiwuIndexBanner},
    // eslint-disable-next-line vue/multi-word-component-names
    name:'index',
    data(){
        return {
            gardlist:[
                {
                    title:'实用工具',
                    doc:'简单精致的实用工具，让您的工作生活更便利',
                    icon:require('../../assets/home/pc/shiyong_pc.png'),
                    icon_ios:require('../../assets/home/iOS/shiyong_pc.png'),
                    img:require('../../assets/home/pc/shiyongimg_pc.png'),
                    bgColor:'linear-gradient(-30deg, #EEFBFF 0%, #F2F7FF 100%)'
                },
                {
                    title:'多媒体',
                    doc:'丰富的视频、音频、DVD软件，让您尽享多媒体',
                    icon:require('../../assets/home/pc/meiti_pc.png'),
                    icon_ios:require('../../assets/home/iOS/meiti_pc.png'),
                    img:require('../../assets/home/pc/meitiimg_pc.png'),
                    bgColor:'linear-gradient(-30deg, #CFF9FF 0%, #F3EDFF 100%)'
                },
                {
                    title:'PDF',
                    doc:'完整高效的PDF解决方案，提升您的办公效率',
                    icon:require('../../assets/home/pc/pdf_pc.png'),
                    icon_ios:require('../../assets/home/iOS/pdf_pc.png'),
                    img:require('../../assets/home/pc/pdfimg_pc.png'),
                    bgColor:'linear-gradient(-30deg, #FFF3EE 0%, #FDF7F5 100%)'
                },
                {
                    title:'数据恢复',
                    doc:'业界领先的恢复技术，让您的数据失而复得',
                    icon:require('../../assets/home/pc/shuju_pc.png'),
                    icon_ios:require('../../assets/home/iOS/shuju_pc.png'),
                    img:require('../../assets/home/pc/shujuimg_pc.png'),
                    bgColor:'linear-gradient(-30deg, #F2F1FF 0%, #F9F5FC 100%)'
                }
            ]
        }
    },
    created(){

    },
    methods:{

    }
}
</script>

<style lang="scss" scoped>
    .uiwu-index{
        margin-top: 72px;
         @media screen and(max-width:1024px) {
            padding: 0 30px;
            margin-top: 62px;
         }
         @media screen and (min-width:320px) and (max-width:767px) {
             padding: 0 .4rem;
             margin-top: .5333rem;
         }
         
        &-gard{
            flex-wrap: wrap;
            justify-content: space-between;
           
            &-item{
                margin-bottom: 30px;
            }
            //  @media screen and (min-width: 768px) and (max-width:1024px)  {
            //      &-item{
            //     margin-bottom: 30px;
            // }
            //  }
              @media screen and (min-width:320px) and (max-width:767px) {
                  padding-top: .1rem;
                &-item{
                    margin-bottom: .4667rem;
                }
            }
        }
        &-num{
            height: 222px;
            background: linear-gradient(0deg, #F1F1F1 0%, #F9F9F9 100%);
            border-radius: 15px;
            margin-top: 40px;
            align-items: center;
            margin-bottom: 53px;
            @media screen and (min-width: 768px) and (max-width:1024px){
                flex-wrap: wrap;
                height: 380px;
                margin-top: 0;
                margin-bottom: 50px;
                margin-top: 20px;
            }
            @media screen and (min-width:320px) and (max-width:767px) {
                flex-wrap: wrap;
                height: 5.56rem;
                margin-bottom: .8rem;
                margin-top: 0;
                margin-top: .3rem;
            }
            li{
                flex: 1;
                align-items: center;
                justify-content: center;
               
                span{
                    font-size: 20px;
                    font-weight: 400;
                    color: #000000;
                }
                p{
                    font-size: 40px;
                    font-weight: bold;
                    color: #12A753;
                    background: linear-gradient(0deg, #12A753 0%, #2ECD73 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    margin-top: 10px;
                }
                 @media screen and (min-width: 768px) and (max-width:1024px){
                     width: 50%;
                    flex: none;
                }
                @media screen and (min-width:320px) and (max-width:767px) {
                    width: 50%;
                    flex: none;
                     span{
                        font-size: .32rem;
                    }
                    p{
                        font-size: .64rem;
                    }
                }
            }
            
        }
    }
</style>